module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/zh-hant-3442ac92eb4de5152b683f60203f4a11.jpg";